module.exports = __webpack_public_path__ + "media/images/emblems/Hagneck-coat_of_arms-bb13032097ab9e39ea8a5a4658543d62.svg";